// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f37c","clinicsSelect":"styles_clinicsSelect__ybawO"};